"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = require("../../../app-reduxs/login/slice");
const icons_1 = require("../../../assets/icons");
const Hamburger_1 = __importDefault(require("../../../assets/icons/Hamburger"));
const Threedoc_1 = __importDefault(require("../../../assets/icons/Threedoc"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalMenu_1 = __importDefault(require("../../../components/modal/ModalMenu"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("../components");
const styles_1 = __importDefault(require("./styles"));
const SubProfileButton = ({ userProfile }) => {
    const [subProfileVisible, setSubProfileVisible] = (0, react_1.useState)(false);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const buttonMenuRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: (_) => {
                const position = buttonMenuRef.current?.getBoundingClientRect();
                setModalPosition({ x: position.right, y: position.bottom });
                setSubProfileVisible(!subProfileVisible);
            }, style: {
                transform: [{ rotateZ: '90deg' }]
            }, ref: buttonMenuRef },
            react_1.default.createElement(Threedoc_1.default, null)),
        react_1.default.createElement(components_2.ProfileSubModal, { visible: subProfileVisible, userId: userProfile.user_id, userHandle: userProfile.user_handle, modalPosition: modalPosition, onClose: () => setSubProfileVisible(false) })));
};
const MyProfileScreen = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isFocused = (0, native_1.useIsFocused)();
    const [menuVisible, setMenuVisible] = (0, react_1.useState)(false);
    const userProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    (0, react_1.useEffect)(() => {
        if (connected) {
            User_1.default.retrieveUser()
                .then((response) => {
                dispatch((0, slice_1.setProfileAction)(response.data.data));
            })
                .catch((err) => {
                console.log(err);
            });
        }
    }, [isFocused, connected]);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    if (!userProfile)
        return react_1.default.createElement(LoadingLogin_1.default, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'マイページ', styleContainer: {
                backgroundColor: 'white',
                marginBottom: 0,
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setMenuVisible(true);
            } }),
        react_1.default.createElement(react_native_1.ScrollView, { style: styles_1.default.body, contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(100),
            }, onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    new react_native_1.NativeEventEmitter().emit(constants_1.listenerEvents.PROFILE_REACHED_END);
                }
            }, scrollEventThrottle: 400, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.Pressable, { disabled: !userProfile.header_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, { uri: userProfile.header_url }) },
                react_1.default.createElement(react_native_1.Image, { source: userProfile.header_url || images_1.images.NoImages, resizeMode: "cover", style: styles_1.default.backgroundImage })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.userInfo },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles_1.default.row,
                        {
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                        },
                    ] },
                    react_1.default.createElement(react_native_1.Pressable, { disabled: !userProfile.thumbnail_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, { uri: userProfile.image_url }) },
                        react_1.default.createElement(react_native_1.Image, { source: userProfile?.thumbnail_url || images_1.images.AvatarDefaul, resizeMode: "cover", style: styles_1.default.avatar })),
                    react_1.default.createElement(SubProfileButton, { userProfile: userProfile })),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.fullName }, userProfile?.nickname || constants_1.DEFAULT_NAME),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.username },
                    "@",
                    userProfile?.user_handle),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { marginTop: (0, scale_1.scale)(12) }] },
                    react_1.default.createElement(components_1.BorderButton, { title: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u7DE8\u96C6", onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.MY_PROFILE_EDITOR), style: styles_1.default.editProfileButton }),
                    react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.MY_PAGE_SCREEN), style: styles_1.default.settingButton },
                        react_1.default.createElement(icons_1.IC_SETTING, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20) }))),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, styles_1.default.followAnalyst] },
                    react_1.default.createElement(react_native_1.Pressable, { style: styles_1.default.followItem, onPress: () => (0, rootNavigation_1.push)(Routes_1.default.FOLLOW_SCREEN, {
                            initTabIndex: 0,
                            userHandle: userProfile?.user_handle,
                        }) },
                        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.followItemLabel }, "\u30D5\u30A9\u30ED\u30FC"),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.followItemValue }, (0, helpler_1.formatNumber)(userProfile.follows))),
                    react_1.default.createElement(react_native_1.Pressable, { style: styles_1.default.followItem, onPress: () => (0, rootNavigation_1.push)(Routes_1.default.FOLLOW_SCREEN, {
                            initTabIndex: 1,
                            userHandle: userProfile?.user_handle,
                        }) },
                        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.followItemLabel }, "\u30D5\u30A9\u30ED\u30EF\u30FC"),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.followItemValue }, (0, helpler_1.formatNumber)(userProfile?.followers)))),
                react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                        color: '#06c',
                        textDecorationLine: 'underline',
                    } },
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.introduce }, userProfile?.biography
                        ?.split(helpler_1.hashtagRegex)
                        .map((string, index) => {
                        if (string.match(helpler_1.hashtagRegex)) {
                            return (react_1.default.createElement(react_native_1.Text, { key: index, style: { color: '#007AFF' } }, string));
                        }
                        else {
                            return react_1.default.createElement(react_native_1.Text, { key: index }, string);
                        }
                    }))),
                !!userProfile?.video_url ? (helpler_1.isWeb ? (react_1.default.createElement(react_native_1.View, { style: styles_1.default.introduceVideo },
                    react_1.default.createElement("video", { width: "100%", height: "100%", controls: true, src: userProfile.video_url }))) : (react_1.default.createElement(react_native_1.View, { style: styles_1.default.introduceVideo }))) : null,
                !!userProfile?.location && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { marginTop: (0, scale_1.scale)(12), alignItems: 'flex-start' }] },
                    react_1.default.createElement(icons_1.IC_LOCATION, { width: (0, scale_1.scale)(18), height: (0, scale_1.scale)(18) }),
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.locationText }, userProfile?.location))),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.date },
                    (0, moment_1.default)(userProfile?.start_date).format('YYYY年MM月'),
                    "\u304B\u3089\u5229\u7528\u3057\u3066\u3044\u307E\u3059")),
            react_1.default.createElement(components_2.TabBar, { userId: userProfile?.user_id, isMyProfile: true, publicHashtags: userProfile?.public_hash_tags || [], privateHashtags: userProfile?.private_hash_tags || [] })),
        react_1.default.createElement(ModalMenu_1.default, { visible: menuVisible, onClose: () => setMenuVisible(false) })));
};
exports.default = MyProfileScreen;
